<template>
    <div class="materiais-graficos">
		<div class="row">
			<c-busca :fieldsProp="fieldsProp" @changeFiltros="changeFiltros"></c-busca>
		</div>

		<div class="row infinite-loading-container">
            <stack v-if="data.length > 0" :column-min-width="230" :gutter-width="4" :gutter-height="4" :monitor-images-loaded="true">
                <stack-item v-for="(item, i) in data" :key="i">
                    <div class="card-content">
                        <img :src="item.image" alt="">
                        <div class="card-information-container">
                            <h4>{{ item.title }}</h4>
                            <p class="card-share-label" v-if="item.redes.length > 0">Compartilhar através de:</p>
                            <p class="card-share-network-label" v-for="network in item.redes" v-bind:key="network.id">{{ network.title }}</p>

                            <div v-if="item.produtos.length > 0">
                                <button class="btn-show-products" @click="isActiveClick(item)">
                                    <i class="fa fa-list" style="padding: 0px 8px;"> </i>
                                    Exibir produtos
                                </button>
                            </div>

                            <a :href="'materiais-graficos/download/' + item.id">
                                <button class="btn btn-download">
                                    <i class="btn-icon icon-downloads"></i>
                                    Download
                                </button>
                            </a>
                        </div>
                        <div class="divider"></div>
                    </div>
                </stack-item>
            </stack>
            <infinite-loading ref="infinite" @infinite="infiniteHandler" v-if="!loading">
                <div slot="spinner">
                    <vue-element-loading :active="true" spinner="bar-fade-scale"/>
                </div>
                <div style="font-size: 0.9em" slot="no-results">
                    <small v-if="data.length === 0">Nenhum resultado encontrado</small>
                    <small v-else>Total de registros carregados: {{data.length}}</small>
                </div>
                <div style="font-size: 0.9em" slot="no-more">
                    <small>Total de registros carregados: {{data.length}}</small>
                </div>
            </infinite-loading>

            <vue-element-loading :active="loading" spinner="bar-fade-scale"/>
		</div>
	</div>
</template>

<style>
        .btn-show-products {
            background: #252642;
            padding: 12px;
            color: #fff;
            font-size: 15px;
            text-transform: uppercase;
            font-weight: 600;
            width: 100%;
            margin-top: 12px;
        }
        
        .btn-show-products:hover {
            background-color: #2978db;
            border-style: dashed;
            border-color: #2978db;
        }

        .custom-alert-title {
            color: #595959 !important;
            text-decoration: underline !important;
            text-decoration-color: #00afef !important;
        }

        .custom-alert-confirm:hover {
            background-color: #2978db !important;
        }
        
</style>

<script>
    import { Stack, StackItem } from 'vue-stack-grid';
    import Swal from 'sweetalert2';

    const baseUrl = typeof _ROOT_PATH === 'undefined'? API_URL : _ROOT_PATH + '/api'

	export default {
        components: { Stack, StackItem },
		props:{
            filtros: [Object, Array]
		},
		data() {
			return {
                fieldsProp: [],
                data: [],
                showCardsIds: [],
                request: { page: 1 },
                loading: false,
                filters: {
                    category: '',
                    network: '',
                    product: '',
                    brand: '',
                    format: '',
                }
			}
		},
		methods: {
            isActiveClick(item) {
                let productList = ''
                let product = item.produtos

                product.forEach(function(product){
                    let productItem = '';

                    productItem = (product.referencia + ' - ' + product.nome + '<br/>')
                    productList = productList + productItem
                })

                Swal.fire({
                    title: item.title,
                    width: 700,
                    html:`<div style="text-align: initial">  ${productList} </div>`,
                    showCloseButton: true,
                    confirmButtonColor: '#252642',
                    customClass:   {
                        title: 'custom-alert-title',
                        confirmButton: 'custom-alert-confirm'
                    }
                })
            },
			changeFiltros(filtros)  {
				this.buscar(Object.assign({}, ...filtros));
            },
            infiniteHandler($state = { loaded() {}, complete() {} }) {
                const params = {
                    ...this.request,
                    ...this.filters
                }

                this.axios.get(baseUrl + '/materiais-graficos/buscar', { params })
                .then((response) =>
                {
                    const data = response.data.data

                    if (data.length > 0) {
                        this.data = this.data.concat(data);
                        this.request.page++;
                        $state.loaded();
                    } else {
                        $state.complete();
                    }

                    if (this.loading) {
                        this.loading = false;
                    }
                })
            },
            buscar(filtros) {
                for (const [key, value] of Object.entries(filtros)) {
                    this.filters[key] = value
                }

                this.request.page = 1;
                
                this.loading = true;
                this.data    = [];
                this.infiniteHandler();
            }
		},
		beforeMount() {
            this.fieldsProp = [
                {name: 'category',  type: 'select',  label: 'Categoria',                                 class: 'column-3',  value: '', completeUrl: true, url: baseUrl + '/materiais-graficos/categorias', option: { value: 'id', text: 'title' }},
                {name: 'network',   type: 'select',  label: 'Rede Social',                               class: 'column-3',  value: '', completeUrl: true, url: baseUrl + '/materiais-graficos/redes',      option: { value: 'id', text: 'title' }},
                {name: 'brand',     type: 'select',  label: 'Marca',                                     class: 'column-2',  value: '', completeUrl: true, url: baseUrl + '/materiais-graficos/marcas',     option: { value: 'id', text: 'nome' }},
                {name: 'product',   type: 'text',    label: 'Produto',                                   class: 'column-4',  value: ''},
                {name: 'format',    type: 'format',  label: 'Escolha o formato do card para a pesquisa', class: 'column-10', value: ''},
            ]
		}
	};
</script>